import type { ReactNode } from 'react';

import type { LabelConfig } from '@repo/sdk/models/components';

import { useFaultReason } from '@/features/equipment-browser/faulted-devices/hooks/use-fault-reason';
import { EMPTY_CELL_LABEL } from '@/features/equipment-browser/reset-faulted/reset-faulted.constants';
import { Typography } from '@/ux-common/components/typography/typography';

interface ResetFaultedFaultReasonCellProps {
  faultReasonLabel?: LabelConfig;
}

/** Live fault reason of the device, or a dash when there is none. */
export const ResetFaultedFaultReasonCell = ({
  faultReasonLabel,
}: ResetFaultedFaultReasonCellProps): ReactNode => {
  const reason = useFaultReason(faultReasonLabel);

  return (
    <Typography
      as="span"
      className="text-body-sm text-foreground truncate px-gutter-sm"
      data-component="ResetFaultedFaultReasonCell"
    >
      {reason ?? EMPTY_CELL_LABEL}
    </Typography>
  );
};
